<template>

    <div class="page-index">
      <heads :logo="logo"></heads>
      <div class="page-ad">
        <swiper  :options="swiperOptions" v-if="adList.length>1">
          <swiper-slide v-for="(item,index) in adList" :key="index"><img :src="globalConfig.imgUrl+item.picture_mobile"/></swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div v-if="adList.length>0 && adList.length===1" v-for="(item,index) in adList"><img :src="globalConfig.imgUrl+item.picture_mobile"/></div>
      </div>
      <div class="page-center">

        <div class="page-list">
          <div class="page-list-item" @click.stop="_url(1)">
            <img src="../../assets/img/kf.png"/>
            <div class="gradient-text">
              <span class="gradient-text-one">{{$t('thalIndex.t_2')}}</span>
            </div>
          </div>
        </div>

        <div class="page-list">
          <div class="page-list-item2" @click.stop="_url(2)">
            <div class="page-list-item">
              <div class="gradient-text">
                <span class="gradient-text-one">{{$t('thalIndex.t_3')}}</span>
              </div>
            </div>
          </div>
          <div class="page-list-item2" @click.stop="_url(3)">
            <div class="page-list-item">
              <div class="gradient-text">
                <span class="gradient-text-one">{{$t('thalIndex.t_4')}}</span>
              </div>
            </div>
          </div>
          <div class="page-list-item2" @click.stop="_urlLottery(item.is_hf,item.id,item.lottery_name,item.is_tally)" v-for="(item,index) in list">
            <div class="page-list-item">
              <div class="gradient-text">
                <span class="gradient-text-one">{{item.lottery_name}}</span>
              </div>
            </div>
          </div>

        </div>

      </div>

      <sesstion ref="sesstion" title="bet"></sesstion>



    </div>

</template>

<script>
  import sesstion from '../THAL/sesstion.vue'
  import heads from "../navs/headr.vue";
    export default {
        name: "index",
      components:{heads,sesstion},
      data(){
        return{
          adList:[],
          swiperOptions:{
            observer:true,//修改swiper自己或子元素时，自动初始化swiper
            observeParents:true,//修改swiper的父元素时，自动初始化swiper
            loop:true,
            autoplay: {
              delay: 2000,
              disableOnInteraction: false
            }
          },
          platform_id:'',
          list:[],
          lottery_abbr:'',
          lottery_id:'',
          is_sesstion:false,
          recordlist:[],
          lottery_name:'',
          logo:'',
        }
      },
      created:function(){
        let that=this;
        let id=that.$route.query.id;
        that.platform_id=id;
        if(id!='' && id!=undefined){
          that._lottery();
        }
        that._banner();
      },
      methods:{
        _config:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'site/config', {}, function (result) {
            if(result.data['status_code']==200){
              _self.logo=result.data['data'].logo;
            }
          })
        },
          _lottery:function (){
            let _self=this;
            this._PublicFun.getData('2', 'get', 'lottery/'+_self.platform_id, {}, function (result) {
              if(result.data['status_code']==200){
                _self.list=result.data['data'];
              }

            })
          },
        _banner:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'ad', {}, function (result) {
            if(result.data['status_code']==200){
              _self.adList=result.data['data'];
            }

          })
        },
          _url:function(m){
            let url=''
            if(m==1){
              url='/THAL/ranking?platform_id='+this.platform_id
            }else if(m==2){
              url='/THAL/Record?platform_id='+this.platform_id
            }else if(m==3){
              url='/THAL/calendar?platform_id='+this.platform_id
            }
            this.$router.push({path:url})
          },

        _urlLottery:function (is_hf,id,lottery_name,is_tally){
            let _self=this;
          _self.$refs.sesstion.lottery_id=id;
          _self.$refs.sesstion.is_hf=is_hf;
          _self.$refs.sesstion.lottery_name=lottery_name;
          _self.$refs.sesstion.is_tally=is_tally
          this.$refs.sesstion._record();


        },
      }
    }
</script>

<style scoped>
  .page-index{
    display: block;
    width: 100%;
    padding: 0;
  }
  .page-center{
    display: block;
    width: 100%;
    margin: 0 auto 0;
    max-width: 750px;
  }
  .page-ad{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 0;
  }
  .page-ad img{
    width: 100%;
    height: auto;
  }
  .page-list{
    display: block;
    width: 90%;
    margin:5px  auto 0;
    padding: 0;
  }
  .page-list-item{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    padding: 8px 0;
    border-style: solid;
    border-width: 5px;
    border-image: linear-gradient(to right, #9E6B1B, #FDDC7A,#9E6C1C) 1;
    border-image-slice: 5;
    background-clip: padding-box;
    clip-path: inset(0 round 5px);
    cursor: pointer;
  }
  .page-list-item img{
    height: 40px;
    width: auto;
  }
  .gradient-text{font-size:20px;font-weight:bolder; position: relative; }
  .gradient-text-one{
    background-image:-webkit-linear-gradient(bottom,#9E6C1C,#DFB963,#FFEDAB);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
    text-shadow: 5px 5px 5px rgba(0,0,0,0.2);

  }
  .page-list-item2{
    display: block;
    float: left;
    width: 48%;
    margin: 8px 0 0 0;
    padding: 0;
  }
  .page-list-item2 .page-list-item{
    /*padding: 25px 0;*/
    height: 70px;
    clip-path: inset(0 round 8px);
  }
  .page-list-item2:nth-child(even){
    margin-left: 2%;
  }
  .page-list-item2:nth-child(odd){
    margin-right: 2%;
  }



</style>



// WEBPACK FOOTER //
// src/components/THAL/index.vue